import { call } from 'redux-saga/effects';

import { imgPath } from '~common/utilities/ImgUrl';
import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PublishedConnectionTableCard } from '~src/publishedConnectionTable/components/cardView/PublishedConnectionTableCard';
import { PublishedConnectionTables } from '~src/publishedConnectionTable/resources/PublishedConnectionTables';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { PublishedConnectionTableContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getPublishedConnectionTableInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';

import { getGenericDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

export const PublishedConnectionTableDefinition: MixedContentItemDefinition & SpaceDefinition<'virtualConnectionTable'>  = {
  contentType: 'virtualConnectionTable',
  itemType: 'virtualConnectionTable',
  pluralName: Messages.publishedConnectionTables,
  singularName: Messages.publishedConnectionTable,
  emptyStateMessage: Messages.publishedConnectionTablesEmpty,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PublishedConnectionTables,
  contentFilterKeys: PublishedConnectionTableContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: PublishedConnectionTableCard,
  listViewIconUrl: imgPath('table_connection_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['virtualConnectionTable']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.publishedConnectionTableUrl(contentId),
  getBasicQuery: () => {
    return PublishedConnectionTables.all().withExtraParams(PublishedConnectionTableContentType.extraQueryParams);
  },
  fieldValueResourceType: 'virtualConnectionTable',
  getContentInfo: (contentList: IContentInfo[]) => call(getPublishedConnectionTableInfos, contentList),
  supportedDisplayModes: ['list'],
  headerIconPath: (contentInfo) => getPublishedConnectionTableIconPath(contentInfo),
};

export const getPublishedConnectionTableIconPath = (contentInfo: ISpaceItemDetailInfo<'virtualConnectionTable'>, headerIcon: boolean = true): string => {
  const properties = [];
  if (contentInfo.hasExtracts) {
    properties.push('extract');
  }
  if (properties.length > 0) {
    properties.push('');
  }

  if (headerIcon) {
    return imgPath(`table_connection_${properties.join('_')}60px_card.svg`);
  } else {
    return imgPath(`table_connection_${properties.join('_')}16px_medium.svg`);
  }
};

